const COOKIE_NAME_RP = 'Rp';
const COOKIE_NAME_RZ = 'Rz';
const SURVEY_EXPIRATION_NAME = 'REX-SURVEY-EXPIRATION-TIME';
const SURVEY_STATE_NAME = 'REX-SURVEY-STATE';
const SURVEY_STATE_VALUE_ANSWERED = 'ANSWERED';
const SURVEY_STATE_VALUE_DECLINED = 'DECLINED';
const SURVEY_API_ENDPOINT_BASE = 'https://form.rakuten.co.jp/ans/apply/';
const TIMEOUT_FOR_AXIOS = 3000;

export default {
  COOKIE_NAME_RP,
  COOKIE_NAME_RZ,
  SURVEY_EXPIRATION_NAME,
  SURVEY_STATE_NAME,
  SURVEY_STATE_VALUE_ANSWERED,
  SURVEY_STATE_VALUE_DECLINED,
  SURVEY_API_ENDPOINT_BASE,
  TIMEOUT_FOR_AXIOS,
};



// WEBPACK FOOTER //
// ./src/components/SurveyToast/businessLogics/constants.js